<template>
  <section
    class="d-flex align-items-center w-100 text-nowrap"
    :class="del ? 'justify-content-between' : 'justify-content-end'"
  >
    <b-btn
      v-if="del"
      class="text-14 text-white py-2"
      @click="deleteEvent()"
      :style="{
        width: '65px',
      }"
    >
      삭제</b-btn
    >
    <div>
      <b-btn
        v-for="(item, i) in btns"
        :key="i"
        :variant="item.variant"
        @click="btnEvent(item.value)"
        class="py-2 ml-3 text-14"
        :style="{
          width: '95px',
        }"
        :disabled="item.disable"
      >
        {{ item.text }}
      </b-btn>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    del: {
      type: Boolean,
    },
    confirmText: {
      default: "확인",
      type: String,
    },
    disable: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    btns() {
      const res = [
        {
          text: "취소",
          value: "cancel",
          variant: "outline-gray-da bg-white text-black",
          disable: false,
        },
        {
          text: this.confirmText,
          value: "confirm",
          variant: "primary",
          disable: this.disable,
        },
      ];
      return res;
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("submit");
    },
    btnEvent(val) {
      this[val]();
    },
    deleteEvent() {
      this.$emit("delete-event");
    },
  },
};
</script>

<style lang="scss" scoped></style>
